import { render } from "./AddQuotaCredit.vue?vue&type=template&id=27461ed7&scoped=true"
import script from "./AddQuotaCredit.vue?vue&type=script&lang=js"
export * from "./AddQuotaCredit.vue?vue&type=script&lang=js"

import "./AddQuotaCredit.vue?vue&type=style&index=0&id=27461ed7&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27461ed7"]])

export default __exports__